import React, { useEffect, useRef } from "react"

/**
 * Renders editor-supplied embed markup and executes the scripts that go with it.
 *
 * Scripts injected via dangerouslySetInnerHTML are inert, so any external or
 * inline script is recreated as a real <script> node once the markup is mounted.
 */
const CodeEmbed = ({ html, scriptUrl, script, className }) => {
  const containerRef = useRef(null)
  const scriptsRef = useRef([])

  useEffect(() => {
    const container = containerRef.current
    if (!container) return undefined

    const added = []

    if (scriptUrl) {
      const external = document.createElement("script")
      external.src = scriptUrl
      external.async = true
      container.appendChild(external)
      added.push(external)
    }

    if (script) {
      const inline = document.createElement("script")
      inline.type = "text/javascript"
      inline.text = script
      container.appendChild(inline)
      added.push(inline)
    }

    scriptsRef.current = added

    return () => {
      scriptsRef.current.forEach(node => {
        if (node.parentNode) node.parentNode.removeChild(node)
      })
      scriptsRef.current = []
    }
  }, [scriptUrl, script])

  if (!html && !scriptUrl && !script) return null

  return (
    <div className={className ? `code-embed ${className}` : "code-embed"} ref={containerRef}>
      {html && (
        <div
          className="code-embed-markup"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </div>
  )
}

export default CodeEmbed
